import getCookie from "@/utils/getCookie"

function hideNavAndBurger() {
    const nav = document.querySelector("header nav")
    if (nav) nav.classList.add("d-md-none")
    const burger: HTMLElement | null = document.querySelector("#header-hamburger-menu")
    if (burger) burger.style.visibility = "hidden"
}

function makeHeaderNotSticky() {
    const headerWrapper: HTMLElement | null = document.querySelector("#header-wrapper")
    if (headerWrapper) headerWrapper.style.position = "unset"
    const headerBanner: HTMLElement | null = document.querySelector("#header-banner")
    if (headerBanner) headerBanner.style.position = "unset"
}

function hideCustomerAccountIfCSE(locale: string) {
    if (locale.indexOf("CSE") === -1) return
    const accountElem: HTMLElement | undefined = document.querySelector(".header-user-account-link") as HTMLElement | undefined
    if (accountElem) accountElem.style.display = "none"
}

function executeScripts(containerId: string) {
    // Get the container element
    const container: HTMLElement | null = document.getElementById(containerId);
    if (!container) throw new Error("container cannot be undefined")
    // Find all script tags in the container
    const scripts = container.getElementsByTagName("script");
    // For each script...
    for (let i = 0; i < scripts.length; i++) {
        const oldScript = scripts[i];
        // Create a new script element
        const newScript = document.createElement("script");
        // Copy the text from the old script into the new one
        newScript.text = oldScript.text;
        // If script has src attribute
        if (oldScript.src) { newScript.src = oldScript.src; }
        // Copy all attributes from old script to new one
        for (let j = 0; j < oldScript.attributes.length; j++) {
            const attrName = oldScript.attributes[j].nodeName;
            newScript.setAttribute(attrName, oldScript.getAttribute(attrName)!);
        }
        // Replace the old script with the new one
        oldScript.parentNode!.replaceChild(newScript, oldScript);
    }
}

const hideAPartOfFooter = () => {
    // hide all exept the footer-trustpilot-container
    const footerElemntsTohide = [
        document.querySelector(".footer-acc"),
        document.querySelector(".footer-contact-us"),
        document.querySelector(".footer-newsletter"),
        document.querySelector(".footer-payment"),
        document.querySelector(".footer-links"),
    ]
    footerElemntsTohide.forEach((element: HTMLElement | null) => {
        if (element) element.style.display = "none";
    })
}

const getHeaderFooterDomain = (hostname: string) => {
    switch (hostname) {
        case "www.uk.travelski.com":
        case "www.nl.travelski.com":
            return hostname.slice(4);
        // DEV ONLY
        case "preprod2.travelski.com":
            return "uk.travelski.com";
        case "preprod1.travelski.com":
            return "www.travelski.com";
        case "express.travelski.com":
            return "www.travelski.com";
        case "localhost": // DEV ONLY
            return "www.benl.yoonly.eu";
    }
    return hostname;
}

export const injectHeaderFooter = async (hostname: string, locale: string, company: string) => {

    let menuDomain = getHeaderFooterDomain(hostname);
    if (!menuDomain) throw new Error("menuDomain cannot be undefined")

    const isCSE = hostname === "cse.travelski.com";
    if (isCSE && company) menuDomain += `/${company}`

    const headerUrl = `https://cms.travelfactory.fr/menu/${menuDomain}/header.html`;
    const footerUrl = `https://cms.travelfactory.fr/menu/${menuDomain}/footer.html`;

    async function fetchHeaderOrFooter(url: string, tag: string) {
        const response = await fetch(url);
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");
        const element = doc.querySelector(tag);
        const bannerElement = doc.querySelector('#header-banner');
        const elementHtml = element ? element.outerHTML : "";
        const bannerElementHtml = bannerElement ? bannerElement.outerHTML : "";
        const linksAndScripts = doc.querySelectorAll('link[href*="header.css"], link[href*="footer.css"], script[src*="header.js"], script[src*="footer.js"]');
        let linksAndScriptsHtml = "";
        linksAndScripts.forEach((ls) => { linksAndScriptsHtml += ls.outerHTML; });
        return { elementHtml, bannerElementHtml, linksAndScriptsHtml };
    }
    const header_wrapper = document.querySelector("#header-wrapper");
    const footer_wrapper = document.querySelector("#footer-wrapper");
    if (!header_wrapper || header_wrapper.innerHTML !== "") throw new Error("header_wrapper cannot be undefined")
    if (!footer_wrapper || footer_wrapper.innerHTML !== "") throw new Error("footer_wrapper cannot be undefined")
    fetchHeaderOrFooter(headerUrl, "header").then((res) => {
        if (!res.elementHtml) {
            console.error("No header for domain: ", menuDomain)
            return
        }
        const { elementHtml, linksAndScriptsHtml, bannerElementHtml } = res;
        header_wrapper.insertAdjacentHTML("afterbegin", elementHtml);
        header_wrapper.insertAdjacentHTML("beforeend", linksAndScriptsHtml);
        header_wrapper.insertAdjacentHTML("afterbegin", bannerElementHtml);
        executeScripts("header-wrapper");
        hideNavAndBurger()
        makeHeaderNotSticky()
        hideCustomerAccountIfCSE(locale)
    });
    fetchHeaderOrFooter(footerUrl, "footer").then((res) => {
        if (!res.elementHtml) {
            console.error("No footer for domain: ", menuDomain)
            return
        } const { elementHtml, linksAndScriptsHtml } = res;
        footer_wrapper.insertAdjacentHTML("afterbegin", elementHtml);
        header_wrapper.insertAdjacentHTML("beforeend", linksAndScriptsHtml);
        executeScripts("footer-wrapper");
        hideAPartOfFooter()
    });
}

